import { render, staticRenderFns } from "./ProdcutUpdate.vue?vue&type=template&id=3614fb78&scoped=true&"
import script from "./ProdcutUpdate.vue?vue&type=script&lang=js&"
export * from "./ProdcutUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3614fb78",
  null
  
)

export default component.exports